import React from 'react';
import { DollarSign, AlertCircle, ArrowDownLeft, ArrowUpRight, Trash2, Edit2 } from 'lucide-react';
import type { Transaction } from './FinanceTypes';

interface TransactionListProps {
  transactions: Transaction[];
  type?: 'invoice' | 'expense';
  onEdit?: (transaction: Transaction) => void;
  onDelete?: (id: string) => void;
}

export function TransactionList({ transactions, type, onEdit, onDelete }: TransactionListProps) {
  const filteredTransactions = type 
    ? transactions.filter(t => t.type === type)
    : transactions;

  return (
    <div className="space-y-3">
      {filteredTransactions.map((transaction) => (
        <div
          key={transaction.id}
          className="flex items-center justify-between p-3 bg-[#bbdde5] rounded-xl"
        >
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-xl ${
              transaction.status === 'paid' ? 'bg-black/10' :
              transaction.status === 'overdue' ? 'bg-black/10' :
              'bg-black/10'
            } flex items-center justify-center`}>
              {transaction.status === 'overdue' ? (
                <AlertCircle className="w-5 h-5 text-black" /> 
              ) : transaction.type === 'expense' ? (
                <ArrowDownLeft className={`w-5 h-5 ${
                  'text-black' 
                }`} />
              ) : (
                <ArrowUpRight className={`w-5 h-5 ${
                  'text-black' 
                }`} />
              )}
            </div>
            <div>
              <p className="font-medium text-black">{transaction.businessName}</p>
              <p className="text-sm text-black/70">
                {new Date(transaction.date).toLocaleDateString()} • {transaction.category}
              </p>
            </div>
          </div>
          <div className="text-right">
            <p className={`font-medium ${
              transaction.type === 'expense' ? 'text-black' : 'text-black' 
            }`}>
              {transaction.type === 'expense' ? '-' : ''}${transaction.amount.toFixed(2)}
            </p>
            <p className={`text-sm ${
              transaction.status === 'paid' ? 'text-black/70' :
              transaction.status === 'overdue' ? 'text-black/70' :
              'text-black/70' 
            }`}>
              {transaction.status.charAt(0).toUpperCase() + transaction.status.slice(1)}
            </p>
            <div className="flex items-center gap-1 mt-1">
              {onEdit && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(transaction);
                  }}
                  className="p-1 hover:bg-black/20 rounded-lg text-black transition-colors"
                >
                  <Edit2 className="w-4 h-4" />
                </button>
              )}
            {onDelete && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(transaction.id);
                }}
                className="p-1 hover:bg-black/20 rounded-lg text-black transition-colors ml-2"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            )}
            </div>
          </div>
        </div>
      ))}
      {filteredTransactions.length === 0 && (
        <div className="text-center text-black/60 py-4">
          No {type || ''} transactions found
        </div>
      )}
    </div>
  );
}